import axios from "axios";

const PUBLIC_PATHS = ["/login", "/signup"];

const isPublicRoute = () =>
  PUBLIC_PATHS.some((path) => window.location.pathname.startsWith(path));

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !isPublicRoute()) {
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axios;
